<ng-container>

  @if (isEditMode && editableContent.editing && editEnabled) {
    <div #editModeContainer class="edit-mode" [style.min-height]="'min(calc(100vh - 100px), ' + minimumHeight + 'px)'" [style.width.px]="displayWidth" [style.top.px]="stickToBottom ? null : offsetTop" [style.bottom.px]="stickToBottom ? 71 : null">
      <ng-container *ngTemplateOutlet="content" />
      <div class="reject" (click)="cancelEdit()"></div>
      <button confirm class="confirm edit-form-button" [loader]="false" (click)="confirmEdit()"></button>
    </div>
  }

  @if (!isEditMode) {
    <div [ngClass]="{ editing: editableContent.editing, editEnabled: editEnabled && clickToEdit }" class="display-mode" #parent (click)="clickedDisplayMode()">
      <ng-container *ngTemplateOutlet="content" />
    </div>
  }

  <ng-template #content><ng-content /></ng-template>
</ng-container>
